const mapConstants = {
  comingDirectionColor: "#EF4349",
  pastDirectionColor: "#3F81C3",

  busStatusClass: "busStatusLayer",
  busStatusWidth: "250px",
  busStatusHeight: "25px",

  infoLayerWrapperClass: "busStatusInfoLayer",
  infoLayerClass: "busStatusInfoLayer-content",
  distanceLayerWrapperClass: "distanceInfoLayer",
};

export default mapConstants;



// WEBPACK FOOTER //
// ./src/core/mapConstants.js